import axios from "axios";

const urlAPI = "/api";

/**
 * Call Api for GET, PUT, DELETE
 * @param {*} method
 * @param {*} route
 * @param {*} id
 * @param {*} body
 */
const CallApi = async (method, route, id, body, header) => {
  const finalResponse = [];
  try {
    let res = await axios({
      method: method,
      headers: {
        "content-type": "application/json",
        Authorization: header,
        refreshToken: header,
      },
      url: `${urlAPI}/${route}/${id}`,
      data: body,
    });
    finalResponse.push(res.data);
  } catch (e) {
    return e;
  }
  return finalResponse;
};

export default CallApi;
